<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication" id="dedication"><a id="page_iii"></a><em>This book is dedicated to<br/>the next generation of<br/>serving leaders.</em><a id="page_iv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?691f4a84